@if (experienceEditorActive$ | async; as active) {
  <ng-template [ngTemplateOutlet]="preview?.templateRef ?? null"></ng-template>
} @else {
  <ng-template [ngTemplateOutlet]="content?.templateRef ?? null"></ng-template>
}
